import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { MFieldType } from '../../../types/MFieldType';
import { getBiLogger } from '../../../utils/biLogger';
import {
  validateEmail,
  validatePhone,
  validateRequired,
} from '../../../utils/validate';

export const logValidationError = ({
  fieldName,
  fieldValue,
  errorMessageKey,
  paymentMethod,
}: {
  fieldName: string;
  fieldValue: string;
  errorMessageKey: string;
  paymentMethod: PaymentMethod;
}): Promise<void> =>
  getBiLogger().checkoutValidationErrors({
    fieldName,
    fieldValue,
    errorMessage: errorMessageKey,
    paymentMethod,
  });

const validators: {
  [key in MFieldType | 'default']?: (value: string) => boolean;
} = {
  default: validateRequired,
  [MFieldType.Email]: validateEmail,
  [MFieldType.PhoneTel]: validatePhone,
};

export const getFieldValidatorFn = (
  type: MFieldType
): ((value: string) => boolean) => validators[type] || validators.default;

// /temp route segment allows migration from incorrect mapping set in FP in the past
// Steps to migrate:
// 1. GAx2 (to allow RB) PayApp/Widget with /temp usage (FP mapping is already set up)
// 2. Replace "cashier.wixapps.net/_api/cashier-metadata => com.wixpress.payment.cashier-metadata" (now that it's not used)
// with "cashier.wixapps.net/_api/cashier-metadata => com.wixpress.payment.cashier-metadata/api"
// 3. Remove /temp route usage from the code and GAx2 (this utility function)
// 4. Remove /temp route from FP mappings
export const patchMetadataServiceBaseURL = (host: string): string => {
  if (host === 'https://cashier.wixapps.net') {
    return host + '/temp';
  }

  // Restaurants are passing this as "host" prop to the Widget, and proxying all requests through their server to
  // https://cashier.wixapps.net/* (mappings in FP for apps.restaurants.com are not applied, their servers aren't in FP)
  if (host === '/cashier/') {
    return host + 'temp';
  }

  return host;
};
